import React, { useCallback, useState } from 'react';

const OPTIONS_WITH_DEFAULT_BEHAVIOR = {
  behavior: 'smooth',
} as ScrollIntoViewOptions;

const scrollIntoView = <T extends HTMLElement>(
  element: T,
  options?: ScrollIntoViewOptions,
) => {
  const { behavior } = options || OPTIONS_WITH_DEFAULT_BEHAVIOR;

  element.scrollIntoView({ ...options, behavior });
};

const useScrollIntoViewOnEvent = <T extends HTMLElement>(
  options?: ScrollIntoViewOptions,
): {
  callbackRef: (node: T) => void;
  onEvent: (event: React.SyntheticEvent<T>) => void;
} => {
  const [element, setElement] = useState<T>();

  const callbackRef = useCallback((node: T) => {
    if (node) {
      setElement(node);
    }
  }, []);

  const onEvent = (_: React.SyntheticEvent<T>) => {
    if (element) {
      scrollIntoView(element, options);
    }
  };

  return { callbackRef, onEvent };
};

export default useScrollIntoViewOnEvent;
